import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction,
  SliceCaseReducers,
  ValidateSliceCaseReducers
} from '@reduxjs/toolkit';

export interface GenericState<T> {
  data: T;
  status: 'loading' | 'finished' | 'error';
  error?: string;
  more?: {
    status: 'loading' | 'finished' | 'error';
    data?: { [key: string]: any };
  };
}

const createGenericSlice = <T, Reducers extends SliceCaseReducers<GenericState<T>>>({
  name = '',
  initialState,
  reducers,
  extraReducers
}: {
  name: string;
  initialState: GenericState<T>;
  reducers: ValidateSliceCaseReducers<GenericState<T>, Reducers>;
  extraReducers?: (builder: ActionReducerMapBuilder<GenericState<T>>) => void;
}) => {
  return createSlice({
    name,
    initialState,
    reducers: {
      start(state) {
        state.status = 'loading';
      },
      success(state: GenericState<T>, action: PayloadAction<T>) {
        state.data = action.payload;
        state.status = 'finished';
      },
      ...reducers
    },
    extraReducers
  });
};

export default createGenericSlice;
